import React from "react"
import PropTypes from "prop-types"
import RiskStatusIndicator from "./RiskStatusIndicator/RiskStatusIndicator"
import "./StatusIndicator.scss"

const statusTypes = ["default", "processing", "success", "warning", "error"]
const StatusIndicator = ({ bgColor, size = "med", status }) => {
  return (
    <span
      style={bgColor ? { backgroundColor: bgColor } : {}}
      className={`status-indicator size-${size} ${status && status}`}
    />
  )
}

StatusIndicator.propTypes = {
  /**
   * The background color of the status indicator.
   * If not provided, the color will be determined based on the `status` prop.
   */
  bgColor: PropTypes.string,
  /**
   * The size of the status indicator.
   */
  size: PropTypes.oneOf(["med", "sm"]),
  /**
   * Determines the color of the status indicator. The bgColor need to be set to null for this to take effect.
   */
  status: PropTypes.oneOf(statusTypes),
}

export default StatusIndicator

StatusIndicator.Risk = RiskStatusIndicator
